export default {"src":"/_next/static/media/secure.3a882cd8.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};